// extracted by mini-css-extract-plugin
export var askAiIcon = "_no-j";
export var category = "_no-9";
export var categoryHeader = "_no-e";
export var container = "_no-0";
export var group = "_no-a";
export var groupItems = "_no-f";
export var groupSeparator = "_no-k";
export var loading = "_no-1";
export var noResults = "_no-3";
export var placeholder = "_no-2";
export var resultContent = "_no-5";
export var resultIcon = "_no-c";
export var resultItem = "_no-g";
export var resultMeta = "_no-8";
export var resultSubtitle = "_no-7";
export var resultSuffix = "_no-i";
export var resultTitle = "_no-6";
export var resultsList = "_no-4";
export var searchGroup = "_no-d";
export var selected = "_no-h";
export var subgroup = "_no-b";